module.exports = __webpack_public_path__ + "img/CCC-HTF-12-2.eb69c9c8.jpg";